import Text from 'components/Text/Text';
import React from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './AddNewFieldButton.module.scss';

interface IAddNewFieldBtnProps {
	onClick: () => void;
	isDisabled?: boolean;
}

const AddNewItemBtn: React.FC<IAddNewFieldBtnProps> = ({ onClick, isDisabled }) => {
	return (
		<Button
			className={style.btn}
			theme="primary"
			disabled={isDisabled}
			onClick={onClick}
			iconPosition="post"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}>
			<Text translationNameSpace="form" translationKey="addButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(AddNewItemBtn);
